

var theWindow ; 


(function ($) {
theWindow = $(window);

// theWindow.trigger("window:resize");

setTimeout(() => {
  document.body.classList.remove("preload");

}, 500);



var resizeTimer; // Set resizeTimer to empty so it resets on page load

function resizeFunction() {
    // Stuff that should happen on resize
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(resizeFunction, 250);
      theWindow.trigger("window:resize");
      // document.body.classList.add("resizing");
      // setTimeout(function(){
      //   document.body.classList.remove("resizing");
      // }, 300);
  });
};

// On resize, run the function and reset the timeout
// 250 is the delay in milliseconds. Change as you see fit.


resizeFunction();



  ///////////////////////////////////////////////////////////////////////////
  //Randomize                                       
  ///////////////////////////////////////////////////////////////////////////

  $.fn.randomize = function (selector) {
    var $elems = selector ? $(this).find(selector) : $(this).children(),
        $parents = $elems.parent();

    $parents.each(function () {
        $(this).children(selector).sort(function (childA, childB) {
            // * Prevent last slide from being reordered
            if($(childB).index() !== $(this).children(selector).length - 1) {
                return Math.round(Math.random()) - 0.5;
            }
        }.bind(this)).detach().appendTo(this);
    });

    return this;
};









var opacityLevel = 10;

  
$('.lessOpacity').on('click', function(){
  opacityLevel--
  $('.tracingTemplate img').css('opacity', opacityLevel/10 )
})
$('.moreOpacity').on('click', function(){
  opacityLevel++
  $('.tracingTemplate img').css('opacity', opacityLevel/10)
})

})(jQuery); // or even jQuery.noConflict()